import React, { useState, useEffect } from "react";
import carIcon from "../../assets/car-icon.png";

import { MdOpenInNew } from 'react-icons/md'
import "./gap-insurance-card.scss";
import CoveredListBox from "../covered-list-box/coveredListBox"

import productsArray  from "../../utils/products.json";

const GapInsuranceCard = ({ props, origin }) => {


    let weddingPrefix = "";
    if (typeof window !== "undefined" && window.location.pathname.includes('wedding-')) {
        weddingPrefix = "wedding-";
    }
    else {
        weddingPrefix = "";
    }

    const [canRender, setCanRender] = useState(false);

    useEffect(() => setCanRender(true));


    return (
        <>
            {
                props.filter((item) => item.origin === origin).map((obj, index) => {
                    const { title, insuranceList } = obj;

                    return (
                        <div className="covered-list-box" key={index} id="covered-list">
                            <div className="insurance-list-content">
                                <div>
                                    <h2 className="covered-list-title">{title}</h2>
                                </div>

                                <div className="covered-list-cards">
                                    <div className="uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2@s  uk-grid-match uk-grid-small uk-grid uk-text-center uk-flex-center" uk-grid="true">
                                        {
                                            insuranceList ? insuranceList.map((item) => {

                                                let gapProduct = productsArray?.find((element) => element.ProducGroupTitle.includes(item.productGroupTitle))


                                                return (
                                                    <div className="padding-left-cards">
                                                        <div className="insurance-list-column">

                                                            <CoveredListBox props={item} />

                                                            <img className="ring-icon" src={carIcon} align="left" alt="ring-icon" />

                                                            <div className="links-insurances">
                                                                <div className="terms-and-conditions">
                                                                    <div><a
                                                                        href={gapProduct?.TC}
                                                                        className="TC"
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <MdOpenInNew />&#8198;View Policy Wording
                                                                    </a></div>
                                                                </div>
                                                                

                                                                <div className="terms-and-conditions">
                                                                    <div><a
                                                                        href={gapProduct?.KeyFacts}
                                                                        className="KF"
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <MdOpenInNew />&#8198;View IPID
                                                                    </a></div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            }
                                            ) : ""
                                        }
                                    </div>
                                </div>

                                <div className="cover-button-container">
                                    {canRender ? <a href={"/" + weddingPrefix + "checkout"} className="cover-button">Get A Quote →</a> : ''}
                                </div>

                            </div>
                        </div>
                    )
                })
            }
        </>
    )
}

export default GapInsuranceCard;


